import React, { createContext, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearMenuPermissions } from '../app/permissionsSlice';
import { clearSoftwareSettings } from '../app/settingsSlice';

import { persistor } from '../app/store';
export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [agentCode, setAgentCode] = useState(null);
  const [dbCode, setdbCode] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userRegisterId, setUserRegisterId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const loggedIn = localStorage.getItem('isAuthenticated') === 'true';
    const storedAgentCode = localStorage.getItem('agentCode');
    const storedDbCode = localStorage.getItem('dbCode');
    const storedToken = localStorage.getItem('authToken');
    const storedUserType = localStorage.getItem('userType');
    const storedUserId = localStorage.getItem('userId');
    const storedUserRegisterId = localStorage.getItem('userRegisterId');
    const storedUaccno = localStorage.getItem('Uaccno');

    // Restore sessionStorage from localStorage if we are authenticated (e.g. browser/tab restarted)
    if (loggedIn && storedToken) {
      if (!sessionStorage.getItem('authToken')) {
        sessionStorage.setItem('authToken', storedToken);
        if (storedAgentCode) sessionStorage.setItem('agentCode', storedAgentCode);
        if (storedUserType) sessionStorage.setItem('userType', storedUserType);
        if (storedDbCode) sessionStorage.setItem('dbCode', storedDbCode);
        if (storedUserId) sessionStorage.setItem('userId', storedUserId);
        if (storedUserRegisterId) sessionStorage.setItem('userRegisterId', storedUserRegisterId);
        if (storedUaccno) sessionStorage.setItem('Uaccno', storedUaccno);
      }
    }

    setIsAuthenticated(loggedIn);
    setAgentCode(storedAgentCode);
    setdbCode(storedDbCode);
    setUserId(storedUserId);
    setUserRegisterId(storedUserRegisterId);
    setLoading(false);
  }, []);

  const login = (agentCode, userType, dbCode, uRights, userIdValue, userRegisterIdValue) => {
    sessionStorage.removeItem("userSelectedFy");
    sessionStorage.setItem("agentCode", agentCode);
    sessionStorage.setItem("userType", userType);
    sessionStorage.setItem("dbCode", dbCode);
    sessionStorage.setItem("userId", userIdValue);
    sessionStorage.setItem("userRegisterId", userRegisterIdValue);
    localStorage.setItem("uRights", JSON.stringify(uRights));

    setIsAuthenticated(true);
    setAgentCode(agentCode);
    setUserId(userIdValue);
    setUserRegisterId(userRegisterIdValue);
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('agentCode', agentCode);
    localStorage.setItem("dbCode", dbCode);
    localStorage.setItem('userId', userIdValue);
    localStorage.setItem('userRegisterId', userRegisterIdValue);
  };

  const logout = () => {
    // Clear sessionStorage
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("agentCode");
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("dbCode");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("userRegisterId");
    sessionStorage.removeItem("Uaccno");
    sessionStorage.removeItem("userSelectedFy");

    setIsAuthenticated(false);
    setAgentCode(null);
    setdbCode(null);
    setUserId(null);
    setUserRegisterId(null);

    // Clear localStorage
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('agentCode');
    localStorage.removeItem('uRights');
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userRegisterId');
    localStorage.removeItem('userType');
    localStorage.removeItem('CustomerName');
    localStorage.removeItem('Uaccno');

    dispatch(clearMenuPermissions());
    dispatch(clearSoftwareSettings());
    persistor.purge(); // Clears storage
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading, agentCode, userId, userRegisterId }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
